import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id F809C249-6B8A-4A3E-B945-7EA3D0F71AB0
 * name earbuds
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earbuds.svg
 * tags
 * - Audio 
 * - Music 
 */
export const EarbudsIcon = createSvgIcon(<><path d="M10 8V20C10 20.55 9.55 21 9 21H8C7.45 21 7 20.55 7 20V13.27C6.32 13.72 5.61 14 5 14C3 14 2 12 2 11V6C2 5 3 3 5 3S10 6 10 8M16.5 3C13.46 3 11 5.46 11 8.5S13.46 14 16.5 14 22 11.54 22 8.5 19.54 3 16.5 3M14.5 14.68V20C14.5 20.55 14.95 21 15.5 21H17.5C18.05 21 18.5 20.55 18.5 20V14.68C17.87 14.89 17.2 15 16.5 15S15.13 14.89 14.5 14.68Z" /></>, 'EarbudsIcon');
export default EarbudsIcon